<!-- eslint-disable -->
<template>
<v-container
    id="dashboard"
    fluid
    tag="section"
  >

    <v-row
        align="center"
        justify="center"
    >

        <v-col
            cols="12"
            sm="6"
            lg="3"
            class="text-center header"
        >
            Logout process..

        </v-col>
    </v-row>

  </v-container>
</template>
<script>

export default {
  name: 'logout',
  mounted () {
    this.logOut()
  },
  methods:{
    logOut () {
      console.log('logout')
      this.$store.commit('CLEAR_USER')
      localStorage.removeItem('user')
      localStorage.removeItem('jwt')

      this.$router.push('/login')
      // window.location.href = "/#/login"
    },
    
  }
}
</script>
<style>
  #bg{
    position:fixed;
    top:0;
    left:0;
    z-index:0;
    min-width:100%;
    min-height:100%
  }
  .center-cropped{
    object-fit:none;
    object-position:center;
    height:100px;
    width:100px
  }

  #cardlogin{
    background-color: rgba(0, 0, 0, 0.7);
  }

  #whitetxt{
    color: white !important;
  }
</style>
<!-- eslint-enable -->